import { create } from 'zustand';

interface ConfirmModalStore {
  isOpen: boolean;
  onOpen: () => void;
  onClose: () => void;
}

const useConfirmModalAgent = create<ConfirmModalStore>(set => ({
  isOpen: false,
  onOpen: () => set({ isOpen: true }),
  onClose: () => set({ isOpen: false }),
}));

export default useConfirmModalAgent;
